import usePostcodeGroupSingle from "../../data/usePostcodeGroupSingle";
import PostcodeYearRules from "./PostcodeYearRules";

/**
 * Reads the group back rather than using the row the modal was opened from — that row is a snapshot
 * taken when the table loaded, so rules added here would not appear until the page was reopened.
 */
export default function EditPostcodeGroupYearRules({ postcodeGroupId }: { postcodeGroupId: string }) {
  const { postcodeGroup } = usePostcodeGroupSingle(postcodeGroupId);

  if (postcodeGroup.isLoading || !postcodeGroup.data) return <></>;

  const group = postcodeGroup.data.data;

  return (
    <div className="flex flex-col gap-y-4 px-4 sm:px-0">
      <PostcodeYearRules
        basePrice={group.basePrice}
        yearRules={group.yearRules ?? []}
        postcodeGroupId={group.id}
        ownerLabel={`group ${group.postcode}`}
      />
    </div>
  );
}
